export default ($resource) => {
    const baseUrl = `${SEED_CORE.ENV.API_URL}notification/notification`;
    const url = `${baseUrl}/:id`;

    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        },
        templateIndex: {
            method: 'GET',
            url: `${url}/template-index`,
            isArray: true
        },
        markAsRead: {
            method: 'POST',
            url: `${url}/mark-as-read`
        },
        updateI18n: {
            method: 'POST',
            url: `${baseUrl}/i18n-update`,
            isArray: true
        },
        publish: {
            method: 'POST',
            url: `${url}/publish`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Notification/index.js